import React from "react";
import { CFormText, CInput } from "@coreui/react";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const Filters = ({
  name,
  onInputChange,
  locations,
  selectedLocations,
  onSelectChange,
  dropdownError
}) => {
  return (
    <>
      <div className="regions__section light">
        <div className="regions__section__el">
          <p>Name</p>
          <CInput
            onChange={(e) => onInputChange(e.target.value)}
            className="text-input"
            type="text"
            placeholder="Add Name"
            value={name}
          />
          <CFormText className="help-block">
            {name && name.trim() ? "" : "* Please add name"}
          </CFormText>
        </div>

        <div className="regions__section__el">
          <p>Locations</p>
          <Dropdown
            includeSelectAll
            height={275}
            haveOnSelectChange
            placeholder="Select Location"
            enableOnly
            options={locations}
            selectedFilters={selectedLocations}
            numberDisplayed={1}
            onSelectChange={onSelectChange}
          />
          <CFormText className="help-block">{dropdownError}</CFormText>
        </div>
      </div>
    </>
  );
};
